<template>
    <main class="container">
        <section style="text-align:center">
            <div style="font-size:7rem;">
                {{ GoConnect.device.recording.duration }}
            </div>

            <div>
                <template v-if="GoConnect.device.recording.isRecording">
                    {{ GoConnect.device.recording.fileSize }}
                </template>
                <template v-else>
                    Not recording..
                </template>
            </div>
        </section>

        <section>
            <header class="container-fluid">
                <div class="row">
                    <div class="col-7 col-sm-8 col-md-9 col-lg-10">
                        <h2>Audio</h2>
                    </div>
                    <div class="col-5 col-sm-4 col-md-3 col-lg-2">
                        <button @click="toggleAudioSettings"
                            class="btn btn-outline-dark btn-sm">
                            Audio Settings
                        </button>
                    </div>
                </div>
            </header>

            <Transition name="slide">
                <div v-if="showAudioSettings">
                    <div>
                        <label for="soundcard" class="form-label">SoundCard</label>
                        <select class="form-control" id="soundcard" name="soundcard"
                            v-model="GoConnect.device.defaultSoundcard" @change="GoConnect.setDefaultSoundcard()">
                            <template v-for="soundcard in GoConnect.device.soundcards" :key="soundcard.device_name">
                                <option :value="soundcard.device_name" :selected="soundcard.device_name == GoConnect.device.defaultSoundcard">
                                    {{ soundcard.name }}
                                </option>
                            </template>
                        </select>

                        <label for="input-gain" class="form-label">Input Gain</label>
                        <input v-model="GoConnect.device.inputGain"
                            @change="GoConnect.setInputGain(GoConnect.device.inputGain)" type="range" min="0" max="131072"
                            class="form-range" id="input-gain" name="input-gain">
                        <label for="audio-loopback" class="form-label">Audio Loopback</label>
                        <button 
                            v-if="!GoConnect.device.audioLoopbackStatus"
                            class="btn btn-outline-dark btn-sm"
                            @click="GoConnect.startAudioLoopback()"
                        >
                            <i class="fas fa-play"></i>
                            Start Audio Loopback
                        </button>
                        <button 
                            v-else
                            class="btn btn-outline-dark btn-sm"
                            @click="GoConnect.stopAudioLoopback()"
                        >
                            <i class="fas fa-stop"></i>
                            Stop Audio Loopback
                        </button>
                    </div>
                    <hr />
                </div>
            </Transition>
            <template v-if="!GoConnect.loading.djrec">
                <meter id="left-channel-vu" class="volume-meter" min="-70" max="0" optimium="-18" low="-16" high="-8"
                    :value="GoConnect.vu.left">
                    {{ GoConnect.vu.left }}
                </meter>

                <meter id="right-channel-vu" class="volume-meter" min="-70" max="0" optimium="-18" low="-16" high="-8"
                    :value="GoConnect.vu.right">
                    {{ GoConnect.vu.right }}
                </meter>
            </template>
            <template v-else>
                <div class="d-flex justify-content-center">
                    <div class="spinner-border" role="status" style="width: 6rem; height: 6rem; margin: 1rem;">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                </div>
            </template>
        </section>

        <section>
            <div class="row">
                <div class="col-2"><button class="btn btn-dark btn-lg" @click="back">
                        <i class="fas fa-arrow-left"></i>
                    </button>
                </div>
                <div class="col-10">
                    <button class="btn btn-dark btn-lg" @click="record" :disabled="GoConnect.loading.djrec || GoConnect.device.recording.awaitingStart || GoConnect.device.recording.awaitingStop">
                        <template v-if="GoConnect.device.recording.awaitingStart || GoConnect.device.recording.awaitingStop">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        </template>
                        <template v-else-if="!GoConnect.device.recording.isRecording">
                            Record
                        </template>
                        <template v-else>
                            Stop
                        </template>
                    </button>
                </div>
            </div>
        </section>
    </main>
</template>

<style>
label:not(:first-child) {
    margin-top: 1rem;
}
</style>

<script setup>
import {
    inject, onMounted, ref,
} from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter();
const GoConnect = inject('GoConnect');
const showAudioSettings = ref(false);

async function toggleAudioSettings() {
    showAudioSettings.value = !showAudioSettings.value;

    if (showAudioSettings.value) {
        await GoConnect.sendMessage({ type: 'get_soundcards' });
        await GoConnect.sendMessage({ type: 'get_input_gain' });
    }
}

function back() {
    router.go(-1);
}

function record() {
    GoConnect.toggleRecording();
}

onMounted( async () => {
    /*if (GoConnect.device.name === null || GoConnect.device.name.trim() === '') {
        GoConnect.onDisconnect();
    }*/
});

</script>
